<template>
  <b-modal
    :id="'comment-request-modal'"
    hide-header
    hide-footer
    centered
    @show="onShow"
    @hidden="closeModal"
    modal-class="modal-custom comment-request-modal"
    no-close-on-backdrop
  >
    <div class="modal-header">
      <div class="modal-title">
        <span>Observação</span>
      </div>
      <span class="icon-close">
        <Close class="stroke" @click="closeModal" />
      </span>
    </div>

    <div class="around-content">

      <h5 class="my-3 product-name">{{ localProduct?.product?.name }}</h5>

      <div class="card" v-for="(item, index) in localProduct.comments" :key="index">
        <div class="card-header py-0 px-2">
          <div class="d-flex">
            <div class="my-auto avatar">
              <img v-if="item.person.picture" :src="item.person.picture" height="35px" width="35px" class="rounded-circle" />
            </div>
            <div class="m-2">
              <strong class="d-block">{{ item.person.name }}</strong>
              <span class="mb-1 text-muted">{{ moment(item.date).format('HH[H]:mm | DD [de] MMMM [de] YYYY') }}</span>
            </div>
          </div>
        </div>
        <div class="card-body p-2">
          <p class="card-text text-comment">
            {{ item.comment }}
          </p>
        </div>
        <hr>
      </div>

      <b-row>
        <b-col class="mt-3" cols="12">
          <div>
            <b-input-group>
              <b-form-input
                type="text"
                v-model="comment"
                debounce="500"
                autocomplete="off"
                placeholder="Escrever"
                :disabled="localProduct.status && localProduct.status !== 'pendente'"
              />
              <b-input-group-append>
                <b-input-group-text>
                  <b-button size="sm" variant="light" @click="addComment">
                    <Send class="icon" />
                  </b-button>
                </b-input-group-text>
              </b-input-group-append>
            </b-input-group>
          </div>
        </b-col>
      </b-row>

    </div>

    <div class="wrapper-button text-right mt-5">
      <b-button variant="primary" size="lg" @click="closeModal">
        Fechar
      </b-button>
    </div>
  </b-modal>

</template>

<script>
import '@/assets/scss/modal-custom.scss';
import { getCurrentClinic, getCurrentUser } from "@/utils/localStorageManager";
import moment from 'moment';
import {EventBus} from "@/utils/eventBus";

export default {
  components: {
    Close: () => import('@/assets/icons/close.svg'),
    Send: () => import('@/assets/icons/send.svg'),
  },
  data() {
    return {
      clinic: getCurrentClinic(),
      user: getCurrentUser(),
      comment: null,
      localProduct: {},
      origin: ''
    }
  },
  props: {
    product: {
      type: Object,
      default: () => ({}),
    },
  },
  async mounted (){
    EventBus.$on('refreshCommentRequest', (product) => {
      this.localProduct = {
        ... product
      }
    });
  },
  methods: {
    // --------- Métodos do Formulário ---------
    addComment() {
      const item = {
        'person_id': this.user.id,
        'person': this.user,
        'date': moment().toDate(),
        'comment': this.comment
      };

      this.localProduct.comments.push(item);

      this.comment = null;

      this.$emit('update-product-request-comment', this.localProduct);
    },
    // --------- Métodos de Gerenciamento do Formulário ---------
    resetForm() {
      this.errors = {};
    },
    isValidForm() {
      const errors = {};

      if(!this.selectedBedSpecialty){
        errors.bed_specialty = "Campo Obrigatório";
      }

      Object.keys(this.requestFields).map(item => {
        if(this.$refs[item] && (!this.$refs[item].value || this.$refs[item].value.length === 0) && this.requestFields[item]){
          errors[item] = "Campo obrigatório";
        }
      });

      this.errors = errors;

      return Object.keys(errors).length;
    },
    saveForm() {
      if (this.isValidForm()) {
        this.$toast.warning('Preencha todos os campos obrigatórios.')
        return
      }
      
      this.closeModal();
    },
    // --------- Métodos de Controle do Modal ---------
    openModal(origin = '') {
      this.origin = origin;
      this.$bvModal.show('comment-request-modal');
    },
    onShow() {
      this.resetForm();
    },
    closeModal() {
      this.comment = null;
      this.$bvModal.hide('comment-request-modal')
    },
  },
  watch: {
    "origin": {
      "handler"(origin) {
        this.origin = origin
      },
      "immediate": true,
    },
    "product": {
      "handler"(product) {
        this.localProduct = {
          ... product
        }
      },
      "immediate": true,
    },
  }
};
</script>
<style lang="scss">  
  .comment-request-modal {

    .avatar {
      width: 40px;
    }

    .product-name {
      color: #525C7A;
      font-size: 16px;
      font-weight: 600;
      line-height: 24px;
      text-align: left;
    }

    .card {
      border: none;

      .card-header {
        border: none;
        background-color: #FFF;
        color: #525C7A;
        font-size: 16px;
      }

      .text-comment {
        color: #8696AC;
      }

    }
    
  }
</style>